import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "linear-gradient(160deg, #f0fdf4 0%, #f8fafc 50%, #ecfdf5 100%)" }}>
      <Navbar />
      <div className="h-1 bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-500" />

      <main className="flex-1 pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          {/* Back */}
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-emerald-600 transition-colors cursor-pointer mb-6"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            Back to Home
          </Link>

          <div className="bg-white rounded-2xl border border-emerald-100 overflow-hidden">
            {/* Header */}
            <div className="px-8 py-8 border-b border-gray-100" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-100 text-emerald-600">
                  <i className="ri-shield-check-line text-xl" />
                </div>
                <h1 className="text-2xl font-bold text-slate-800">Privacy Policy</h1>
              </div>
              <p className="text-slate-500 text-sm">Last updated: April 2026</p>
            </div>

            {/* Content */}
            <div className="px-8 py-8 space-y-8 text-slate-600 text-sm leading-relaxed">
              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">1. Information We Collect</h2>
                <p>
                  Sonic Express Services collects only the information necessary to provide parcel tracking services. This includes tracking numbers you enter into our system, and basic usage data such as pages visited and time spent on the site. We do not require account registration to use our tracking service.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">2. How We Use Your Information</h2>
                <p className="mb-2">We use the information we collect to:</p>
                <ul className="list-disc list-inside space-y-1 text-slate-500 pl-2">
                  <li>Provide real-time parcel tracking results</li>
                  <li>Improve the performance and reliability of our platform</li>
                  <li>Respond to support inquiries sent via email</li>
                  <li>Maintain the security and integrity of our systems</li>
                </ul>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">3. Data Sharing</h2>
                <p>
                  We do not sell, trade, or rent your personal information to third parties. Parcel tracking data is only accessible to the sender, recipient, and authorized Sonic Express Services administrators. We may share data with law enforcement if required by applicable law.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">4. Cookies</h2>
                <p>
                  Our website uses minimal cookies to maintain language preferences and basic session functionality. We do not use tracking cookies or third-party advertising cookies. You can disable cookies in your browser settings without affecting core tracking functionality.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">5. Data Retention</h2>
                <p>
                  Parcel tracking records are retained for as long as the shipment is active and for a reasonable period thereafter for dispute resolution purposes. You may contact us to request deletion of any data associated with your shipment.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">6. Security</h2>
                <p>
                  We implement industry-standard security measures to protect your data, including encrypted connections (HTTPS) and restricted admin access. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">7. Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy or how your data is handled, please contact us at:{" "}
                  <a href="mailto:sonicexpresservices@gmail.com" className="text-emerald-600 hover:underline font-medium">
                    sonicexpresservices@gmail.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
